// Ephemeral memory only. Never persist candidate data or session keys to disk.
let identity = null
let generation = 0
const reads = new Map()
const lists = new Map()
const clone = value => JSON.parse(JSON.stringify(value))
export function sessionIdentity() {
  return ['employer.token', 'employer.ghost', 'employer.childOrganisationId'].map(key => window.localStorage.getItem(key) || '').join('\n')
}
export function sessionGeneration() {
  const current = sessionIdentity()
  if (current !== identity) { identity = current; invalidateSessionCache() }
  return generation
}
export function invalidateSessionCache() {
  generation++
  reads.clear()
  lists.clear()
}
export function sessionRead(key, fetch, ttl = 60000) {
  const version = sessionGeneration()
  const cached = reads.get(key)
  if (cached && cached.expires > Date.now()) return cached.promise.then(clone)
  const entry = { expires: Date.now() + ttl }
  entry.promise = Promise.resolve().then(fetch).then(value => {
    if (version !== sessionGeneration()) throw new Error('Workspace changed. Refresh to continue.')
    return value
  }).catch(error => { if (reads.get(key) === entry) reads.delete(key); throw error })
  reads.set(key, entry)
  return entry.promise.then(clone)
}
export function readList(key) {
  sessionGeneration()
  const entry = lists.get(key)
  return entry && entry.expires > Date.now() ? clone(entry) : null
}
export function saveList(key, data, scroll, version) {
  if (version !== sessionGeneration()) return
  if (lists.size >= 12 && !lists.has(key)) lists.delete(lists.keys().next().value)
  lists.set(key, { data: clone(data), scroll, expires: Date.now() + 60000 })
}
export function listScroll(path) {
  const entry = readList(path)
  return entry ? { x: 0, y: entry.scroll } : null
}
export function rememberList(fields, loadingField = 'loading', suffix = '') {
  return {
    created() {
      if (process.env.VUE_APP_SATELLITE !== 'testcandidates') return
      this.listCacheVersion = sessionGeneration()
      this.listCacheKey = this.$route.fullPath + suffix
      const cached = readList(this.listCacheKey)
      if (cached) {
        fields.forEach(key => { this[key] = cached.data[key] })
        this[loadingField] = false
        this.listRestored = true
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.listCacheKey = to.fullPath + suffix
      this.listCacheVersion = sessionGeneration()
      this.listRestored = false
      next()
    },
    beforeDestroy() {
      // A pending filter request must never label old rows with the new filters.
      if (this.listCacheVersion !== undefined && !this[loadingField] && !this.error && !this.initialError && !this.listRefreshing) {
        const data = {}
        fields.forEach(key => { data[key] = this[key] })
        saveList(this.listCacheKey, data, window.scrollY, this.listCacheVersion)
      }
    }
  }
}
